var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"top-top-container",on:{"click":_vm.handleClick}},[_vm._v(" Top ")])
}
var staticRenderFns = []

export { render, staticRenderFns }